import {
  LoadingScreen,
  NoAccessScreen,
  PaymentProcess,
} from "../../components";
import { AppFeature } from "../../Constant";
import { usePagePermission } from "../../Hook";

export const PaymentProccessPage = () => {
  const { isLoading, hasPermission } = usePagePermission(
    AppFeature.PAYMENT_PROCCESS,
    ["admin", "cashier", "manager"]
  );

  if (isLoading) {
    return <LoadingScreen messageQueue={"Loading..."} />;
  }

  if (!hasPermission) {
    return <NoAccessScreen />;
  }

  return (
    <>
      <div className="w-full min-h-screen text-dark">
        <div className="grid relative">
          <PaymentProcess />
        </div>
      </div>
    </>
  );
};
